import { cn } from '@/lib/utils'
import { type VariantProps, cva } from 'class-variance-authority'
import { forwardRef } from 'react'

const homeSectionVariants = cva('mx-auto px-4 sm:px-6 lg:px-8', {
  variants: {
    padding: {
      none: '',
      sm: 'py-12 md:py-16',
      base: 'py-16 md:py-20',
      lg: 'py-20 md:py-24',
      xl: 'py-24 md:py-32',
    },
    layout: {
      default: '',
      grid: 'grid grid-cols-1 lg:grid-cols-2 items-center gap-12 md:gap-16 lg:gap-24',
      'grid-reverse': 'grid grid-cols-1 lg:grid-cols-2 items-center gap-12 md:gap-16 lg:gap-24',
      center: 'flex flex-col items-center',
    },
    background: {
      none: '',
      overlay: 'relative',
    },
  },
  defaultVariants: {
    padding: 'base',
    layout: 'default',
    background: 'none',
  },
})

export interface HomeSectionProps extends React.HTMLAttributes<HTMLElement>, VariantProps<typeof homeSectionVariants> {
  as?: 'section' | 'div'
}

const HomeSection = forwardRef<any, HomeSectionProps>(
  ({ className, padding, layout, background, as: Comp = 'section', children, ...props }, ref) => {
    return (
      <Comp className={cn(homeSectionVariants({ padding, layout, background, className }))} ref={ref} {...props}>
        {children}
      </Comp>
    )
  },
)

HomeSection.displayName = 'HomeSection'

export { HomeSection, homeSectionVariants }
